import React from "react";
import "./VirasatInputComponents.scss"

const VirsatTextArea = ({ label, value, onChange, placeholder, required, error, errorText, disable }) => {


    return (
        <div className="VirasatInputComponents-VirasatDefault">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`VirasatInputComponents-VirasatDefault-container ${error ? "error" : disable ? "disable" : ""}`}>
                <textarea
                    className="VirasatInputComponents-VirasatDefault-container-textareanew"
                    value={value}
                    onChange={onChange}
                    type="text"
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default VirsatTextArea